import { FunctionalComponent, h } from '@stencil/core';

export const enum Type {
  H1 = 1,
  H2 = 2,
  H3 = 3,
  H4 = 4,
  H5 = 5,
  H6 = 6,
  DIV = 99,
}

export const enum Variant {
  H1 = 1,
  H2 = 2,
  H3 = 3,
}

export const enum HeadlineFadeDirection {
  NONE = '',
  LEFT = 'fadein-left',
  RIGHT = 'fadein-right',
  BOTTOM = 'fadein-bottom',
  TOP = 'fadein-top',
}

export interface HeadlineProps {
  type: Type;
  variant: Variant;
  reveal?: boolean;
  content?: string;
  fadeIn?: HeadlineFadeDirection;
}

export const Headline: FunctionalComponent<HeadlineProps> = ({ type, variant, reveal, content, fadeIn }, children) => {
  return (
    <rudy-headline type={type} variant={variant} reveal={reveal} content={content} fadeIn={fadeIn}>
      {children}
    </rudy-headline>
  );
};
